import { OVERLAY_SET_DATA } from "../actions/types";

const initialState = {
    title: null,
    content: null,
    show: false,
    onClose: () => {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case OVERLAY_SET_DATA:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
};
